import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { RegistrationAdminDto } from '../models/registration-admin.model';
import { AgentCurrencyDto, AgentCurrencyListDto } from '../models/agent-currency.model';

@Injectable({ providedIn: 'root' })
export class RegistrationAdminService {

  constructor(private http: HttpServices) {
  }


  addAdminDecision(adminDecision: RegistrationAdminDto) {
    return this.http.post('Agent/AdminDecisionAgent', adminDecision);
  }
  addTreasuryConfirmation(treasuryConfirmation: RegistrationAdminDto) {
    return this.http.post('Agent/TreasuryConfirmPayment', treasuryConfirmation);
  }

  getAgentCurrency(agentId: string) {
    return this.http.get('AgentCurrency/GetAgentCurrency?AgentId=' + agentId);
  }
  UpdateTreasuryNumbers(agenCurrency: AgentCurrencyListDto) {
    
    return this.http.post('AgentCurrency/UpdateTreasuryNumbers', agenCurrency);
  }
  CheckMainTreasuryNumber(TreasuryNumber: string) {
    return this.http.get('Agent/DuplicateTreasuryNumber?TreasuryNumber=' + TreasuryNumber);
  }
  UpdateProfileTreasuryNumbers(agenCurrency: AgentCurrencyListDto) {

    return this.http.post('AgentCurrency/UpdateProfileTreasuryNumbers', agenCurrency);
  }
  UpdateTreasuryNumbersOfflineAgents(agenCurrency: AgentCurrencyListDto) {

    return this.http.post('AgentCurrency/UpdateTreasuryNumbersOfflineAgents', agenCurrency);
  }


  CheckTreasuryNumber(TreasuryNumber: string) {
    return this.http.get('AgentCurrency/DuplicateTreasuryNumber?TreasuryNumber=' + TreasuryNumber);
  }

  AdminDecisionAgentProfile(adminDecision: RegistrationAdminDto) {
    return this.http.post('Agent/AdminDecisionAgentProfile', adminDecision);
  }


  AgentList(pageIndex: number, pageSize: number, searchName: string, sortBy: string, sortDirection: string) {
    return this.http.get('Agent/AgentList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&searchName=' + searchName + '&sortBy=' + sortBy + '&sortDirection=' + sortDirection);
  }

  ActivateOfflineAgent(AgentId: string) {
    return this.http.get('Agent/ActivateOfflineAgent?AgentId='+ AgentId);
  }

  DeActivateAgent(AgentId: string) {
    return this.http.get('Agent/DeActivateAgent?AgentId=' + AgentId);
  }

  ActivateRepresentative(UserId: string) {
    return this.http.get('Agent/ActivateRepresentative?UserId=' + UserId);
  }

  DeActivateRepresentative(UserId: string) {
    return this.http.get('Agent/DeActivateRepresentative?UserId=' + UserId);
  }

  ActivateAgentDueFees(adminDecision: RegistrationAdminDto) {
    return this.http.post('Agent/ActivateAgentDueFees', adminDecision);
  }


  ActivateAgentDueCertificate(adminDecision: RegistrationAdminDto) {
    return this.http.post('Agent/ActivateAgentDueCertificate', adminDecision);
  }

}